module.exports = __webpack_public_path__ + "img/project2_small.0e061855.jpg";